(() => {
if(window.fdFigmaLoaded)return;window.fdFigmaLoaded=true;
const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:window.Shopify?.currency?.active||'GBP'}).format(n/100);
function purchase(){
 document.querySelectorAll('product-info:has(.fdg-marker)').forEach(root=>{
  if(root.dataset.fdgReady)return;root.dataset.fdgReady='true';
  const picker=root.querySelector('variant-picker');
  const price=root.querySelector('.product__price');


  const jd=root.querySelector('.jdgm-all-reviews-text');
  function rating(){const el=jd?.querySelector('[data-number-of-reviews]');if(el){const text=`${Number(el.dataset.score).toFixed(1)} · ${el.dataset.numberOfReviews} store reviews`;if(el.textContent!==text){el.textContent=text;}}}
  if(jd){new MutationObserver(rating).observe(jd,{childList:true,subtree:true,attributes:true,attributeFilter:['data-score','data-number-of-reviews']});rating();}
  function balance(data){const variantsNode=root.querySelector('[data-fdg-variants]');if(!variantsNode)return;const variants=JSON.parse(variantsNode.textContent);const selectedNode=root.querySelector('variant-picker [data-selected-variant]');const selected=data?.variant||(selectedNode?JSON.parse(selectedNode.textContent):variants.find(variant=>String(variant.id)===root.querySelector('input[name=\"id\"]')?.value)||variants[0]);if(!selected)return;const index=Number(variantsNode.dataset.paymentIndex);const full=variants.find(v=>/^(full price|full payment|pay in full)$/i.test(v.options[index])&&v.options.every((x,i)=>i===index||x===selected.options[i]));const priceEl=root.querySelector('.product__price .price__regular');if(full&&priceEl)priceEl.textContent=money(full.price);let p=root.querySelector('.fdg-balance');if(!p){p=document.createElement('p');p.className='fdg-balance';p.setAttribute('aria-live','polite');root.querySelector('variant-picker')?.append(p);}const paymentChoices=root.querySelector('.fd-payment-choices');if(paymentChoices&&paymentChoices.nextElementSibling!==p)paymentChoices.after(p);if(p&&full){const remainder=full.price-selected.price;p.textContent=remainder>0?`${money(selected.price)} today · ${money(remainder)} balance before dispatch`:'Pay in full. No remaining balance.';}}
  new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(n=>n.nodeType===1&&!n.matches('.fdg-balance,.fdg-price-caption'))))queueMicrotask(()=>balance());}).observe(root,{childList:true,subtree:true});
  root.querySelector('form.product-form')?.addEventListener('variant:change',event=>balance({variant:event.detail.variant}));
  balance();if(window.theme?.pubsub)theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange,e=>{if(String(e.data.productId)===String(root.dataset.productId)){queueMicrotask(()=>{root.querySelectorAll('.fd-ref-choice-amount').forEach(n=>{const updated=e.data.parsedHTML?.getElementById(n.id);if(updated)n.innerHTML=updated.innerHTML;});balance(e.data);});}});
 });
}
  function initialiseReviews() {
    document.querySelectorAll('[data-collector-carousel]').forEach(carousel => {
      if(carousel.dataset.fdgReady)return;carousel.dataset.fdgReady='true';
      const source = carousel.querySelector('[data-review-source]');
      const track = carousel.querySelector('[data-review-track]');
      const dialog = carousel.querySelector('[data-review-dialog]');
      const dialogContent = carousel.querySelector('[data-review-dialog-content]');
      const previous = carousel.querySelector('[data-review-prev]');
      const next = carousel.querySelector('[data-review-next]');
      let signature = '';
      let focusReturn;
      const element = (tag,className,text) => {const node=document.createElement(tag);if(className)node.className=className;if(text!==undefined)node.textContent=text;return node;};
      const safeMedia = url => {if(typeof url!=='string'||!url.trim())return '';try {const parsed=new URL(url.trim(),document.baseURI);return ['http:','https:'].includes(parsed.protocol)?parsed.href:'';}catch{return '';}};
      function stars(rating) {
        const node=element('span','fdc-review-stars');node.setAttribute('aria-label',`${rating} out of 5 stars`);
        const url=safeMedia(carousel.dataset.starIcon||'');
        if(url){for(let i=0;i<rating;i++){const icon=element('img','fdc-review-star-icon');icon.src=url;icon.alt='';icon.width=18;icon.height=18;icon.addEventListener('error',()=>icon.replaceWith(document.createTextNode('★')),{once:true});node.append(icon);}}else node.textContent='★'.repeat(rating);
        return node;
      }
      function navigate(direction) {
        const width = track.querySelector('.fdc-review-card')?.getBoundingClientRect().width || track.clientWidth;
        track.scrollBy({left:direction*(width+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      function refreshArrows(){previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
      previous.addEventListener('click',()=>navigate(-1)); next.addEventListener('click',()=>navigate(1));track.addEventListener('scroll',refreshArrows,{passive:true});
      new ResizeObserver(refreshArrows).observe(track);
      dialog.querySelector('.fdc-dialog-close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>focusReturn?.focus());
      function openReview(review,button) {
        focusReturn=button;dialogContent.replaceChildren();
        if(review.image){const img=element('img');img.src=review.image;img.alt='Review media';dialogContent.append(img);}
        dialogContent.append(element('h3','',review.name),stars(review.rating),element('p','',review.text));
        dialog.showModal();
      }
      function render() {
        const seen=new Set();
        const reviews=[...source.querySelectorAll('.jdgm-card[data-review-id]')].filter(node=>{const id=node.dataset.reviewId;if(seen.has(id))return false;seen.add(id);return true;}).map(node=>{
          const img=node.querySelector('img');
          return {id:node.dataset.reviewId,name:node.querySelector('.jdgm-reviewer-name')?.textContent.trim()||'Collector',text:node.querySelector('.jdgm-text')?.textContent.trim()||'',rating:node.querySelectorAll('.jdgm-star.jdgm--on').length,verified:!!node.querySelector('.jdgm-reviewer-verified-icon'),image:img?safeMedia(img.getAttribute('src')||img.getAttribute('data-src')||''):''};
        }).filter(review=>review.text.length>0).sort((a,b)=>Number(!!b.image)-Number(!!a.image));
        const nextSignature=JSON.stringify(reviews);
        if(!reviews.length||nextSignature===signature)return;
        signature=nextSignature;track.replaceChildren();
        reviews.forEach(review=>{
          const card=element('article','fdc-review-card'+(review.image?'':' fdc-review-text-card'));card.setAttribute('role','listitem');
          if(review.image){const img=element('img');img.src=review.image;img.loading='lazy';img.alt='Photo supplied by the review app';card.append(img);}
          const body=element('div','fdc-review-body');const meta=element('div','fdc-review-meta');
          const badge=element('span','fdc-review-verified');const badgeUrl=safeMedia(carousel.dataset.badgeIcon||'');if(badgeUrl){const icon=element('img','fdc-review-badge-icon');icon.src=badgeUrl;icon.alt='';icon.width=12;icon.height=12;badge.append(icon);}badge.append(document.createTextNode(review.verified?'✓ Verified buyer':'Collector review'));meta.append(element('strong','fdc-review-name',review.name),badge);body.append(meta,stars(review.rating));
          body.append(element('p','',review.text));
          if(review.text.length>140){const read=element('button','fdc-read-more','Read more');read.type='button';read.setAttribute('aria-label',`Read ${review.name}’s full review`);read.addEventListener('click',()=>openReview(review,read));body.append(read);}
          card.append(body);track.append(card);
        });
        carousel.querySelector('[data-review-loading]').hidden=true;refreshArrows();
      }
      new MutationObserver(render).observe(source,{childList:true,subtree:true,attributes:true,attributeFilter:['src','data-src']});render();
      const loading=carousel.querySelector('[data-review-loading]');
      const timeout=setTimeout(()=>{if(!signature){loading.textContent=carousel.dataset.unavailable;previous.hidden=true;next.hidden=true;}},15000);
      new MutationObserver(()=>{if(signature){clearTimeout(timeout);previous.hidden=false;next.hidden=false;}}).observe(track,{childList:true});
    });
  }

function initialiseComparisons(){
 document.querySelectorAll('[data-collector-comparison]').forEach(comparison=>{
  if(comparison.dataset.keyboardReady)return;comparison.dataset.keyboardReady='true';
  const handle=comparison.querySelector('[data-comparison-handle]');
  const sync=()=>{const raw=parseFloat(comparison.style.getPropertyValue('--percent'));handle.setAttribute('aria-valuenow',Math.round(Number.isFinite(raw)?raw:50));};
  new MutationObserver(sync).observe(comparison,{attributes:true,attributeFilter:['style']});
  handle.addEventListener('keydown',event=>{let value=Number(handle.getAttribute('aria-valuenow'));if(event.key==='ArrowLeft')value-=5;else if(event.key==='ArrowRight')value+=5;else if(event.key==='Home')value=0;else if(event.key==='End')value=100;else return;event.preventDefault();value=Math.max(0,Math.min(100,value));comparison.style.setProperty('--percent',value+'%');sync();});
 });
}
function init(){initialiseComparisons();purchase();initialiseReviews();document.querySelectorAll('[data-collector-return]').forEach(a=>a.href='#CollectorPurchase');}
document.addEventListener('shopify:section:load',init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* Animate purchase disclosures without browser scroll anchoring the gallery. */
(() => {
  function setupDetails() {
    document.querySelectorAll('.fdc-purchase-details details').forEach(details => {
      if (details.dataset.fdMotion) return;
      details.dataset.fdMotion = 'true';
      const summary = details.querySelector('summary');
      let animation;
      let expanded = details.open;
      summary.addEventListener('click', event => {
        event.preventDefault();
        const start = details.getBoundingClientRect().height;
        expanded = !expanded;
        animation?.cancel();
        details.open = true;
        details.style.height = 'auto';
        const end = expanded ? details.scrollHeight : summary.getBoundingClientRect().height;
        summary.setAttribute('aria-expanded', String(expanded));
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = expanded;
          details.style.height = '';
          return;
        }
        details.style.overflow = 'hidden';
        animation = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 380, easing: 'cubic-bezier(.22, 1, .36, 1)' });
        animation.onfinish = () => {
          details.open = expanded;
          details.style.height = '';
          details.style.overflow = '';
          animation = null;
        };
      });
      summary.setAttribute('aria-expanded', String(expanded));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDetails, { once: true });
  else setupDetails();
  document.addEventListener('shopify:section:load', setupDetails);
})();


(() => {
  function initialiseFAQs(scope = document) {
    scope.querySelectorAll('.fdg-faq-grid').forEach(grid => {
      if (grid.dataset.fdFaqReady) return;
      grid.dataset.fdFaqReady = 'true';
      const items = Array.from(grid.querySelectorAll(':scope > details'));
      const states = new Map();
      const desktop = matchMedia('(min-width: 750px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      function finish(item, expanded) {
        item.open = expanded;
        item.style.height = '';
        item.style.overflow = '';
      }
      function setExpanded(item, expanded) {
        const state = states.get(item);
        if (state.expanded === expanded && !state.animation) return;
        const start = item.getBoundingClientRect().height;
        state.animation?.cancel();
        state.expanded = expanded;
        item.dataset.faqExpanded = String(expanded);
        item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
        item.open = true;
        item.style.height = 'auto';
        const styles = getComputedStyle(item);
        const closedHeight = item.querySelector('summary').getBoundingClientRect().height +
          parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) +
          parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        const end = expanded ? item.getBoundingClientRect().height : closedHeight;
        if (reduced.matches) { state.animation = null; finish(item, expanded); return; }
        item.style.overflow = 'hidden';
        const animation = item.animate({ height: [start + 'px', end + 'px'] }, {
          duration: 480, easing: 'cubic-bezier(.25,.8,.25,1)'
        });
        state.animation = animation;
        animation.onfinish = () => {
          if (state.animation !== animation) return;
          state.animation = null;
          finish(item, state.expanded);
        };
      }
      let initialOpen = false;
      items.forEach(item => {
        const expanded = item.open && !initialOpen;
        initialOpen ||= expanded;
        item.open = expanded;
        states.set(item, { expanded, animation: null });
        item.dataset.faqExpanded = String(expanded);
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', String(expanded));
        summary.addEventListener('click', event => {
          event.preventDefault();
          const expand = !states.get(item).expanded;
          if (expand) items.forEach(other => {
            if (other !== item && states.get(other).expanded) setExpanded(other, false);
          });
          setExpanded(item, expand);
        });
      });
      function arrange() {
        items.forEach(item => {
          const state = states.get(item);
          state.animation?.cancel(); state.animation = null;
          finish(item, state.expanded);
        });
        if (desktop.matches) {
          const columns = [document.createElement('div'), document.createElement('div')];
          columns.forEach(column => column.className = 'fdg-faq-column');
          items.forEach((item, index) => columns[index % 2].append(item));
          grid.replaceChildren(...columns);
        } else grid.replaceChildren(...items);
      }
      arrange();
      desktop.addEventListener('change', arrange);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseFAQs(), { once: true });
  else initialiseFAQs();
  document.addEventListener('shopify:section:load', event => initialiseFAQs(event.target));
})();
